(function () {
  function setup() {
    var original = document.querySelector('header-drawer .header__icon--menu');
    var section = document.querySelector('.section-header');
    if (!original || !section) return;
    var media = window.matchMedia('(min-width: 990px)');
    /* Boutiqueafwerking uitsluitend voor de bestaande zwevende desktopbalk. */
    if (!document.getElementById('lmg-be-boutique-style')) {
      var boutiqueStyle = document.createElement('style');
      boutiqueStyle.id = 'lmg-be-boutique-style';
      boutiqueStyle.textContent = [
        '@media(min-width:990px){',
        '.lmg-floating-nav-button{width:44px!important;height:44px!important;border-radius:12px!important;background:linear-gradient(155deg,#fffaf2 0%,#f3e7d6 65%,#e8d5bd 100%)!important;border:1px solid #bc9569!important;color:#94704c!important;box-shadow:inset 0 1px 1px #fffdf5,inset 0 -2px 4px #aa825a24,0 3px 8px #6c4d3029!important;transition:background .2s,box-shadow .2s,transform .2s!important;}',
        '.lmg-floating-nav-button svg{width:23px!important;height:23px!important;stroke:#956f48!important;stroke-width:1.8!important;filter:drop-shadow(0 1px 0 #fff7ea)!important;}',
        '.lmg-floating-nav-button:hover{background:linear-gradient(155deg,#fffdf7,#eddfca)!important;box-shadow:inset 0 1px 1px #fff,0 5px 12px #6c4d3033!important;transform:translateY(-1px);}',
        '.lmg-floating-cart-count{background:#947452!important;color:#fff!important;border:1px solid #f5ebdf!important;}',
        '.lmg-floating-nav-button::after{background:#f5f0e8!important;color:#60483c!important;border:1px solid #a58b6d!important;border-radius:10px!important;box-shadow:0 2px 6px #00000016!important;font:16px Georgia,serif!important;padding:10px 13px!important;}',
        '.lmg-floating-dog-button img,.lmg-floating-cat-button img{object-fit:contain!important;}',
        '}'
      ].join('');
      document.head.appendChild(boutiqueStyle);
    }

    var icons = {
      menu: '<path d="M4 6h16M4 12h16M4 18h16"/>',
      search: '<circle cx="10.8" cy="10.8" r="6.3"/><path d="M15.5 15.5 21 21"/>',
      cart: '<path d="M3 4h2l2.2 11h11.5l2-8H6"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/>',
      dog: '<path d="M8 5 5 4 6 7 3 7 5 10 2 12 5 14 3 17 7 17 8 20 11 19 12 21 14 19 17 20 18 17 21 17 19 14 22 12 19 10 21 7 18 7 19 4 16 5c-2-3-6-3-8 0z"/><path d="M8 12h.01M16 12h.01M10 16q2 2 4 0M10 14l2-1 2 1-2 2z"/>',
      cat: '<path d="M4 10 3 3l6 4c2-1 4-1 6 0l6-4-1 7v5a8 8 0 0 1-16 0z"/><path d="M9 13h.01M15 13h.01M10 16l2 1 2-1M12 17v2M1 14l8 3M1 19l8-1M23 14l-8 3M23 19l-8-1"/>',
      up: '<path d="M12 20V4M5 11l7-7 7 7"/>',
      truck: '<path d="M2 6h12v11H2zM14 10h4l4 4v3h-8z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
      voerplan: '<rect x="2.5" y="4.5" width="19" height="17" rx="2.5"/><path d="M7 2.5v4M17 2.5v4M2.5 9h19"/><path d="M12 19.2c-2.1-1.5-4.8-3.4-4.8-5.6 0-2.3 3.1-3.2 4.8-.9 1.7-2.3 4.8-1.4 4.8.9 0 2.2-2.7 4.1-4.8 5.6z"/>',
      gift: '<rect x="3" y="10" width="18" height="11" rx="1"/><path d="M2 7h20v4H2zM12 7v14M12 7c-6-1-7-6-4-6 2 0 4 3 4 6zM12 7c6-1 7-6 4-6-2 0-4 3-4 6z"/>'
    };
    function svg(name) {
      return '<svg viewBox="0 0 24 24" width="21" height="21" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + icons[name] + '</svg>';
    }
    function button(className, title, iconName) {
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'lmg-floating-nav-button ' + className;
      el.setAttribute('aria-label', title);
      el.setAttribute('data-tooltip', title);
      el.innerHTML = svg(iconName);
      document.body.appendChild(el);
      return el;
    }
    function link(className, title, iconName, href) {
      var el = document.createElement('a');
      el.href = href;
      el.className = 'lmg-floating-nav-button ' + className;
      el.setAttribute('aria-label', title);
      el.setAttribute('data-tooltip', title);
      el.innerHTML = svg(iconName);
      document.body.appendChild(el);
      return el;
    }
    var menu = button('lmg-floating-menu-button', 'Menu openen', 'menu');
    menu.setAttribute('aria-controls', 'menu-drawer');
    var cart = link('lmg-floating-cart-button', 'Bekijk de inhoud van jouw winkelwagentje hier', 'cart', '/cart');
    var count = document.createElement('span');
    count.className = 'lmg-floating-cart-count';
    count.setAttribute('aria-label', '0 artikelen in winkelwagen');
    count.textContent = '0';
    cart.appendChild(count);
    var search = button('lmg-floating-search-button', 'Naar wat is je hond of kat op zoek..?', 'search');
    var dog = link('lmg-floating-dog-button', 'Navigeer naar de afdeling hondenvoeding', 'dog', '/pages/hondenvoeding');
    var cat = link('lmg-floating-cat-button', 'Navigeer naar de afdeling kattenvoeding', 'cat', '/pages/kattenvoeding');
    var up = button('lmg-floating-up-button', 'Terug naar boven', 'up');
    dog.innerHTML = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAABwklEQVR42q1XMZLDIAxcmPvXfQEXUKS5r9xrUtiF/UOlwRlFlkAQM8NMYhtYVqsVhP+/X0y2HUBi/wuArf4m8W3oTfYzCSILEACwNr6nHpg4AYDEokVZJCjPqLL4NSOSbh4Ki/4gxqb6W451A6GReDcA5crmKueJAyCOSRC8bXWeC8MjGkm4pz1F5g0DKQ0BZ4emOCvDWUOGMPf6jgA8aoeyU2Jd21TyAGmBSCxtn4Luk/5TU0VhaJMZFQxnzcwrwk3ayEpYzk0dFhBygLj1m9gJicdX9gkzvOjF0shhqZu919JxpGBm7i3RQL6IZzI9lwqmdACXhhHyerVIjXAXXZiY7hKspZ89GrFON7tp17WjoFvTAAznhGFw1BGnZB4AiiXWRaTdY6IOZQcT5zqbt9bMZIY365oWvwvNrIMFsQy4bQZA0UCaJnYfjNrUCuV2hj0aMRt1R/5+dbDgOgYEgbpn9VqWaM+zAPqxTuyIKYsdEktVbUwwgO8KUx+n+tC4YFFDmKvjApUdYXqPj52T98HuKGffOrHP7OSm3XV4f9eh6DQcCyRnbxUhSI0L2GX+2Ssnn4QaDusulhHfN43qMFqxXxR2hv/TyL+hAAAAAElFTkSuQmCC" alt="" width="34" height="30" style="display:block;object-fit:contain">';
    cat.innerHTML = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAZCAYAAABU+vysAAABWElEQVR42s1WQY7FIAhF03vNFehCFrOZq8xpZlEXckNmUxPDgMX++T+fxNhUBB7g0/T99QGGyDmnc24AgOrflcjwre38sZGDRvdhswQHAAArp+g52Jz/7GxKCimp9c9hHwFADQJ1A/mZRD8rTdhxtDR1qOlLJMPrhe8Egk8IZH+XjNwqDT/Bp6wEUpw0NsUT3t4rnXAgxwM9cxiAPN653SO8qFMdWigWocmCk/1BnTJkjT1mxeDFtarTHNuoS5OMYaXZasAWOCFo2GPtMxudLpMs0aQMFCgbDnP3VXpGRHU6G8450Jz1QoecoA8AkM25riVwlItak0mfoMpuVXolq5vWI6JeSws1nWs82UcG0NFX3YyuTkbHi4FUo/KOrffMlGHmfCqRcWK6cVIoSpD8mjo1yckWAwBugcdwR96RHYtsnCIEuELxu0IxEy/Dy2/W/6D6t38qmvILQmRkomepKl0AAAAASUVORK5CYII=" alt="" width="34" height="25" style="display:block;object-fit:contain">';
    /* Alleen de naam van beide voedingsafdelingen vet in de bestaande tooltip. */
    [ [dog, 'Hondenvoeding'], [cat, 'Kattenvoeding'] ].forEach(function(item){
      var el=item[0], label=item[1];
      el.removeAttribute('data-tooltip');
      var tip=document.createElement('span');
      tip.className='lmg-voeding-tooltip';
      tip.setAttribute('aria-hidden','true');
      tip.appendChild(document.createTextNode('Navigeer naar de afdeling '));
      var bold=document.createElement('strong');bold.textContent=label;tip.appendChild(bold);
      el.appendChild(tip);
    });
    if(!document.getElementById('lmg-voeding-tooltip-style')){
      var tipStyle=document.createElement('style');tipStyle.id='lmg-voeding-tooltip-style';
      tipStyle.textContent='@media(min-width:990px){.lmg-floating-dog-button::after,.lmg-floating-cat-button::after{display:none!important;content:none!important}.lmg-voeding-tooltip{display:none;position:absolute;left:calc(100% + 13px);top:50%;transform:translateY(-50%);width:max-content;max-width:calc(100vw - 90px);padding:10px 13px;background:#f5f0e8;color:#60483c;border:1px solid #a58b6d;border-radius:10px;box-shadow:0 2px 6px #00000016;font:16px Georgia,serif;font-weight:400;white-space:nowrap;pointer-events:none;z-index:9999}.lmg-voeding-tooltip strong{font-weight:700}.lmg-floating-dog-button:hover .lmg-voeding-tooltip,.lmg-floating-dog-button:focus-visible .lmg-voeding-tooltip,.lmg-floating-cat-button:hover .lmg-voeding-tooltip,.lmg-floating-cat-button:focus-visible .lmg-voeding-tooltip{display:block}}';
      document.head.appendChild(tipStyle);
    }
    var truck = button('lmg-floating-truck-button', 'Jouw verzendvoordeel', 'truck');
    var gift = link('lmg-floating-gift-button', 'Ontdek je extra voordeel', 'gift', '/collections/exclusieve-aanbiedingen');
    // Uitgebreide informatie bij het cadeau-icoon, met echte alinea's.
    gift.removeAttribute('data-tooltip');
    var giftPopup = document.createElement('div');
    giftPopup.className = 'lmg-boutique-info-popup lmg-gift-info-popup';
    giftPopup.hidden = true;
    var giftTexts = [
      'Verzilver je extra voordeel en maak gebruik van onze "Exclusieve aanbiedingen" die bestaan uit leuke kortingen.',
      'Bekijk onze bundels die samen gesteld zijn uit koppelverkoop, twee kopen en één gratis, 20- 30 en 40% korting, weekenddeals enz..'
    ];
    giftTexts.forEach(function (txt, index) {
      var p = document.createElement('p');
      var delen = txt.split(/(onze(?= "Exclusieve aanbiedingen")|Exclusieve aanbiedingen|leuke kortingen|bundels|koppelverkoop|twee kopen en één gratis, 20- 30 en 40% korting|weekenddeals)/g);
      delen.forEach(function(deel, i) {
        if (i % 2 === 1) {
          var strong = document.createElement('strong');
          strong.textContent = deel;
          p.appendChild(strong);
        } else {
          p.appendChild(document.createTextNode(deel));
        }
      });
      p.style.margin = index === giftTexts.length - 1 ? '0' : '0 0 14px 0';
      giftPopup.appendChild(p);
    });
    document.body.appendChild(giftPopup);
    function showGiftPopup() {
      if (gift.hidden) return;
      var b = gift.getBoundingClientRect();
      giftPopup.style.left = (b.right + 12) + 'px';
      giftPopup.hidden = false;
      giftPopup.style.top = Math.max(10, Math.min(window.innerHeight - giftPopup.offsetHeight - 10, b.top - 20)) + 'px';
    }
    function hideGiftPopup() { giftPopup.hidden = true; }
    gift.addEventListener('mouseenter', showGiftPopup);
    gift.addEventListener('mouseleave', hideGiftPopup);
    gift.addEventListener('focus', showGiftPopup);
    gift.addEventListener('blur', hideGiftPopup);
    var voerplan = link('lmg-floating-voerplan-button', 'LMA Animal Store Voerplan', 'voerplan', '/pages/lma-animal-store-voerplan');
    voerplan.removeAttribute('data-tooltip');
    var voerplanPopup=document.createElement('div');
    voerplanPopup.className='lmg-boutique-info-popup';
    voerplanPopup.hidden=true;
    voerplanPopup.innerHTML="<strong>LMA Animal store voerplan.</strong>\nBereken via onze generator wanneer je opnieuw een zak <strong>honden</strong> of <strong>kattenbrokken</strong> nodig hebt.\nLaat het ons jouw makkelijk maken.\nWij berichten jouw vijf dagen op voorrand per e-mail dat het moment aangebroken is om een nieuwe zak honden of kattenbrokken te <strong>bestellen.</strong>";
    document.body.appendChild(voerplanPopup);
    function showVoerplanPopup(){if(voerplan.hidden)return;var b=voerplan.getBoundingClientRect();voerplanPopup.style.left=(b.right+12)+'px';voerplanPopup.style.top=Math.max(10,Math.min(window.innerHeight-290,b.top-20))+'px';voerplanPopup.hidden=false;}
    voerplan.addEventListener('mouseenter',showVoerplanPopup);
    voerplan.addEventListener('mouseleave',function(){voerplanPopup.hidden=true;});
    voerplan.addEventListener('focus',showVoerplanPopup);
    voerplan.addEventListener('blur',function(){voerplanPopup.hidden=true;});

    if (!document.getElementById('lmg-be-boutique-hover-style')) {
      var bs=document.createElement('style');bs.id='lmg-be-boutique-hover-style';
      bs.textContent='.lmg-floating-boutique-button{padding:0!important;overflow:hidden}.lmg-floating-boutique-button::after{display:none!important}.lmg-boutique-info-popup{position:fixed;z-index:1000;max-width:calc(100vw - 110px);width:500px;background:#f5f0e8;color:#60483c;border:1px solid #a58b6d;border-radius:12px;padding:18px 21px;box-shadow:0 4px 15px #0002;font:15px/1.65 Georgia,serif;white-space:pre-line;pointer-events:none}.lmg-boutique-info-popup[hidden]{display:none!important}@media(max-width:989px){.lmg-boutique-info-popup{display:none!important}}';
      bs.textContent += '.lmg-floating-boutique-button{width:44px!important;height:44px!important;border-radius:12px!important;overflow:hidden!important}.lmg-floating-boutique-button img{width:100%!important;height:100%!important;object-fit:cover!important;object-position:center!important;transform:scale(1.5)!important;border-radius:0!important}.lmg-floating-boutique-button:hover img{transform:scale(1.5)!important}';
      document.head.appendChild(bs);
    }
    var boutique = link('lmg-floating-boutique-button', 'Ontdek LM Group Belgium', 'gift', 'https://www.lmgroupbelgium.com/');
    boutique.target = '_blank';
    boutique.rel = 'noopener noreferrer';
    boutique.removeAttribute('data-tooltip');
    boutique.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/1017/2760/0967/files/lm-group-wereldbol-winkelwagen-boutique.png?v=1793283375" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:11px">';
    var boutiquePopup = document.createElement('div');
    boutiquePopup.className = 'lmg-boutique-info-popup';
    boutiquePopup.hidden = true;
    boutiquePopup.innerHTML = "Betreedt de wereld van <strong>LM Group Belgium</strong> dat zich uitgebouwd heeft tot <strong>online winkelcentrum.</strong>\nVan stijlvolle mode en sfeervolle woondecoratie tot wellness, geschenken en bijzondere vondsten.\n<strong>Onze huislijn</strong> in <strong>Iris LMP Parfum</strong>, een geur die blijft hangen lang nadat jij al vertrokken bent.\n<strong>Onze huislijn</strong> in <strong>Iris LMW Wellness</strong>,een gevoel dat je meedraagt naar waar je ook gaat.\nBezoek onze veelzijdige webshop, waar stijl, comfort en inspiratie samenkomen.\n<strong>Een wereld vol mogelijkheden, op één adres.</strong>";
    document.body.appendChild(boutiquePopup);
    boutique.addEventListener('mouseenter', function(){ if(boutique.hidden)return; var b=boutique.getBoundingClientRect();boutiquePopup.style.left=(b.right+12)+'px';boutiquePopup.style.top=Math.max(10,Math.min(window.innerHeight-325,b.top-20))+'px';boutiquePopup.hidden=false; });
    boutique.addEventListener('mouseleave', function(){boutiquePopup.hidden=true;});
    boutique.addEventListener('focus', function(){if(boutique.hidden)return;var b=boutique.getBoundingClientRect();boutiquePopup.style.left=(b.right+12)+'px';boutiquePopup.style.top=Math.max(10,b.top-20)+'px';boutiquePopup.hidden=false;});
    boutique.addEventListener('blur', function(){boutiquePopup.hidden=true;});
    var all = [menu, cart, search, truck, gift, boutique, voerplan, dog, cat, up];
    var panel = document.createElement('div');
    panel.className = 'lmg-shipping-panel';
    panel.hidden = true;
    panel.innerHTML = '<div class="lmg-shipping-panel__heading"><strong>Jouw verzendvoordeel</strong><button type="button" aria-label="Sluiten">×</button></div><label>Afleverland <select><option value="BE">België</option><option value="NL">Nederland</option><option value="DE">Duitsland</option><option value="FR">Frankrijk</option><option value="LU">Luxemburg</option></select></label><p class="lmg-shipping-panel__message"></p><small>Indicatie op basis van het winkelwagenbedrag. Definitieve kosten bij het afrekenen.</small>';
    document.body.appendChild(panel);
    var countrySelect = panel.querySelector('select');
    var currentCountry = (window.Shopify && window.Shopify.country) || 'BE';
    if (['BE','NL','DE','FR','LU'].indexOf(currentCountry) >= 0) countrySelect.value = currentCountry;
    var cartTotal = 0;
    function renderShipping() {
      var rules = { BE:[50,8],NL:[75,9],DE:[75,10],FR:[75,13],LU:[75,12] };
      var rule = rules[countrySelect.value], gap = Math.max(0, rule[0]-cartTotal);
      var fmt = function (v) { return new Intl.NumberFormat('nl-BE',{style:'currency',currency:'EUR'}).format(v); };
      panel.querySelector('.lmg-shipping-panel__message').textContent = gap > 0 ?
        'Nog ' + fmt(gap) + ' tot gratis verzending. Normaal tarief: ' + fmt(rule[1]) + '.' :
        'Je hebt de drempel voor gratis verzending bereikt!';
    }
    countrySelect.addEventListener('change', renderShipping);
    // Het verzendvenster is de hoverinformatie; voorkom een overlappende tooltip.
    truck.removeAttribute('data-tooltip');
    truck.setAttribute('aria-controls','lmg-shipping-popup');
    panel.id = 'lmg-shipping-popup';
    truck.setAttribute('aria-expanded','false');
    var shippingHoverTimer;
    function closeShippingPanel() {
      clearTimeout(shippingHoverTimer);
      panel.hidden = true;
      truck.setAttribute('aria-expanded','false');
    }
    function openShippingPanel() {
      clearTimeout(shippingHoverTimer);
      if (truck.hidden) return;
      var wasHidden = panel.hidden;
      panel.hidden = false;
      truck.setAttribute('aria-expanded','true');
      if (wasHidden) refreshCart();
    }
    function scheduleShippingClose() {
      clearTimeout(shippingHoverTimer);
      shippingHoverTimer = setTimeout(function () {
        if (!truck.matches(':hover') && !panel.matches(':hover') &&
            !truck.matches(':focus') && !panel.contains(document.activeElement)) {
          closeShippingPanel();
        }
      }, 220);
    }
    panel.querySelector('button').addEventListener('click', closeShippingPanel);
    truck.addEventListener('mouseenter', openShippingPanel);
    truck.addEventListener('mouseleave', scheduleShippingClose);
    truck.addEventListener('focus', openShippingPanel);
    truck.addEventListener('blur', scheduleShippingClose);
    truck.addEventListener('click', openShippingPanel);
    panel.addEventListener('mouseenter', function () { clearTimeout(shippingHoverTimer); });
    panel.addEventListener('mouseleave', scheduleShippingClose);
    panel.addEventListener('focusin', function () { clearTimeout(shippingHoverTimer); });
    panel.addEventListener('focusout', scheduleShippingClose);
    var left = 18, top = 70;
    function setCount(n) {
      var value = Math.max(0, Number(n) || 0);
      count.textContent = value > 99 ? '99+' : String(value);
      count.setAttribute('aria-label', value + ' artikelen in winkelwagen');
      cart.setAttribute('aria-label', 'Bekijk de inhoud van jouw winkelwagentje hier, ' + value + ' artikelen');
    }
    function refreshCart() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) { if (data) { setCount(data.item_count); cartTotal = (data.total_price || 0)/100; renderShipping(); } })
        .catch(function () {});
    }
    var refreshTimer;
    function scheduleRefresh() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshCart, 300);
    }
    var searchForm = document.createElement('form');
    searchForm.className = 'lmg-floating-search-form';
    /* Ruimte voor de volledige zoekvraag, zonder iconenbalk of zoekknop te wijzigen. */
    searchForm.style.setProperty('width', '470px', 'important');
    searchForm.style.setProperty('max-width', 'calc(100vw - 110px)', 'important');
    searchForm.style.setProperty('box-sizing', 'border-box', 'important');

    searchForm.action = '/search';
    searchForm.method = 'get';
    searchForm.setAttribute('role','search');
    searchForm.hidden = true;
    searchForm.innerHTML = '<label class="visually-hidden" for="lmg-floating-query">Zoek producten</label><input id="lmg-floating-query" type="search" name="q" placeholder="Naar wat is jouw hond of kat op zoek..?" required><button type="submit" aria-label="Zoeken">Zoek</button>';
    document.body.appendChild(searchForm);
    if(!document.getElementById('lmg-search-tooltip-fix')){var fix=document.createElement('style');fix.id='lmg-search-tooltip-fix';fix.textContent='.lmg-floating-search-button.lmg-search-expanded::after{display:none!important}.lmg-floating-search-form:not([hidden]){display:flex!important;align-items:center!important;gap:8px!important}.lmg-floating-search-form[hidden]{display:none!important}.lmg-floating-search-form #lmg-floating-query{flex:1 1 0%!important;width:0!important;min-width:0!important;max-width:none!important;box-sizing:border-box!important}.lmg-floating-search-form button[type="submit"]{flex:0 0 auto!important}';document.head.appendChild(fix);}
    var searchHideTimer;
    function openFloatingSearch(focusInput) {
      clearTimeout(searchHideTimer);
      var b=search.getBoundingClientRect();
      searchForm.style.top=b.top+'px';
      searchForm.style.left=(b.right+9)+'px';
      searchForm.hidden=false;
      search.classList.add('lmg-search-expanded');
      if(focusInput) searchForm.querySelector('input').focus();
    }
    function scheduleSearchClose() {
      clearTimeout(searchHideTimer);
      searchHideTimer=setTimeout(function(){
        if(!search.matches(':hover')&&!searchForm.matches(':hover')&&!searchForm.contains(document.activeElement)){searchForm.hidden=true;search.classList.remove('lmg-search-expanded');}
      },180);
    }
    search.addEventListener('mouseenter',function(){openFloatingSearch(false);});
    search.addEventListener('mouseleave',scheduleSearchClose);
    searchForm.addEventListener('mouseenter',function(){clearTimeout(searchHideTimer);});
    searchForm.addEventListener('mouseleave',function(){if(searchForm.contains(document.activeElement))searchForm.querySelector('input').blur();scheduleSearchClose();});
    search.addEventListener('click',function(){openFloatingSearch(true);});
    search.addEventListener('focus',function(){openFloatingSearch(false);});
    searchForm.addEventListener('focusout',scheduleSearchClose);
    up.addEventListener('click', function () { window.scrollTo({top:0,behavior:'smooth'}); });
    menu.addEventListener('click', function () {
      section.classList.add('shopify-section-header-sticky');
      section.classList.remove('shopify-section-header-hidden');
      original.click();
      update();
    });
    /* Discrete verticale scrollpijlen voor beperkte desktophoogte. */
    var navItems=[menu,cart,search,truck,gift,boutique,voerplan,dog,cat,up];
    var navIndex=0,navCount=navItems.length,navCompact=false,navActive=false;
    function navArrow(id,label,path) {
      var e=document.createElement('button');e.type='button';e.id=id;
      e.className='lmg-be-scroll-arrow';e.setAttribute('aria-label',label);e.title=label;e.hidden=true;
      e.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="'+path+'"/></svg>';
      document.body.appendChild(e);return e;
    }
    var navUp=navArrow('lmg-be-scroll-up','Vorige iconen','m6 14 6-6 6 6');
    var navDown=navArrow('lmg-be-scroll-down','Volgende iconen','m6 10 6 6 6-6');
    if(!document.getElementById('lmg-be-scroll-style')){
      var navStyle=document.createElement('style');navStyle.id='lmg-be-scroll-style';
      navStyle.textContent='.lmg-be-scroll-arrow{position:fixed;z-index:55;display:flex;align-items:center;justify-content:center;width:28px;height:26px;box-sizing:border-box;padding:0;border:1px solid #bc9569;border-radius:8px;color:#8b7355;background:linear-gradient(155deg,#fffaf2,#f3e7d6);box-shadow:0 2px 6px #6c4d3021;cursor:pointer;opacity:.93}.lmg-be-scroll-arrow:hover:not(:disabled){background:#eddfca;opacity:1}.lmg-be-scroll-arrow:disabled{opacity:.35;cursor:default;box-shadow:none}.lmg-be-scroll-arrow[hidden]{display:none!important}@media(max-width:989px){.lmg-be-scroll-arrow{display:none!important}}';
      document.head.appendChild(navStyle);
    }
    function hideNavPopups(){
      panel.hidden=true;truck.setAttribute('aria-expanded','false');
      searchForm.hidden=true;search.classList.remove('lmg-search-expanded');
      giftPopup.hidden=true;boutiquePopup.hidden=true;voerplanPopup.hidden=true;
    }
    function scrollNav(direction){
      if(!navCompact||!navActive)return false;
      var max=Math.max(0,navItems.length-navCount);
      var next=Math.max(0,Math.min(max,navIndex+direction));
      if(next===navIndex)return false;
      navIndex=next;hideNavPopups();update();return true;
    }
    navUp.addEventListener('click',function(){scrollNav(-1)});
    navDown.addEventListener('click',function(){scrollNav(1)});
    document.addEventListener('wheel',function(e){
      if(!navCompact||!navActive||Math.abs(e.deltaY)<1)return;
      var target=e.target;
      if(!navItems.some(function(el){return el===target||el.contains(target)})&&target!==navUp&&target!==navDown)return;
      if(scrollNav(e.deltaY>0?1:-1))e.preventDefault();
    },{passive:false});
    function update() {
      if (!media.matches) {
        panel.hidden = true;
        boutiquePopup.hidden = true;
        voerplanPopup.hidden = true;
        giftPopup.hidden = true;
        searchForm.hidden = true;
        all.forEach(function (el) { el.hidden = true; });
        navUp.hidden=true;navDown.hidden=true;navActive=false;navCompact=false;
        return;
      }
      var rect = original.getBoundingClientRect();
      if (window.scrollY < 30 && rect.width) {
        left = Math.max(8, Math.round(rect.left));
        top = Math.max(12, Math.round(rect.top));
      }
      var main = document.querySelector('#MainContent');
      var onHome = main && main.dataset.template === 'index';
      var contentWidth = Math.min(1200, window.innerWidth - 40);
      var safeLeft = Math.max(0, (window.innerWidth - contentWidth) / 2);
      var enoughRoom = (safeLeft - left >= 60) && window.innerWidth >= 1280;
      if (main && main.querySelector('.lmg-sticky-links .lmg-hub__rail')) enoughRoom = false;
      /* De cartpagina gebruikt een bredere indeling: houd de zwevende balk beschikbaar. */
      if (window.location.pathname.replace(/\/$/,'') === '/cart' && window.innerWidth >= 1280) enoughRoom = true;
      if (onHome) {
        var cards = main.querySelector('.multicolumn-card, .lm-tegels__tile');
        if (cards) enoughRoom = enoughRoom && cards.getBoundingClientRect().left - left >= 60;
      }
      var headerVisible = rect.bottom > 0 && rect.top < window.innerHeight &&
        !section.classList.contains('shopify-section-header-hidden');
      var menuOpen = !!document.querySelector('#Details-menu-drawer-container[open]');
      // Op de homepage pas tonen zodra de volledige hoofdbanner uit beeld is.
      // De zekerhedenbalk onder de banner hoeft niet eerst voorbij te zijn.
      var homeBanner = onHome ? main.querySelector('.shopify-section .banner') : null;
      var trustStrip = onHome ? main.querySelector('.lm-trust-strip') : null;
      var pastHomeIntro = !onHome || (homeBanner
        ? homeBanner.getBoundingClientRect().bottom <= 0
        : (trustStrip ? trustStrip.getBoundingClientRect().bottom <= 0 : false));
      var active = enoughRoom && window.scrollY >= 30 && pastHomeIntro && !menuOpen && (!headerVisible || section.classList.contains('shopify-section-header-sticky'));
      all.forEach(function (el) { el.hidden = !active; });
      if (!active) { panel.hidden = true; searchForm.hidden = true; boutiquePopup.hidden=true; voerplanPopup.hidden=true; giftPopup.hidden=true; }
      if (!active) { navUp.hidden=true;navDown.hidden=true;navActive=false;navCompact=false;return; }
      all.forEach(function (el) { el.style.left = left + 'px'; });
      // Twee icoonposities (2 x 46 px) hoger dan voorheen; andere pagina's ongewijzigd.
      var floatingTop = onHome ? Math.max(20, Math.max(top, 225) - 92) : top;
      var back = Array.from(document.querySelectorAll('a,button')).find(function (el) {
        if (all.indexOf(el)!==-1 || el===navUp || el===navDown)return false;
        var label=(el.textContent||'').trim(),r=el.getBoundingClientRect();
        return label.includes('Terug')&&label.length<25&&r.width>0&&r.left<185&&r.top>=0&&r.top<window.innerHeight;
      });
      var backTop=back?back.getBoundingClientRect().top:window.innerHeight-92;
      var upTop=backTop-54;
      var normalUpHidden=upTop<floatingTop+418||upTop<8||upTop+36>window.innerHeight-12;
      navCompact=(floatingTop+368+44>window.innerHeight-12)||normalUpHidden;
      navActive=true;
      if(!navCompact){
        navIndex=0;navCount=navItems.length;navUp.hidden=true;navDown.hidden=true;
        menu.style.top=floatingTop+'px';cart.style.top=(floatingTop+51)+'px';
        search.style.top=(floatingTop+92)+'px';truck.style.top=(floatingTop+138)+'px';
        gift.style.top=(floatingTop+184)+'px';boutique.style.top=(floatingTop+230)+'px';
        voerplan.style.top=(floatingTop+276)+'px';dog.style.top=(floatingTop+322)+'px';
        cat.style.top=(floatingTop+368)+'px';up.style.top=upTop+'px';up.hidden=normalUpHidden;
      }else{
        var navTop=Math.max(10,Math.min(floatingTop,window.innerHeight-125));
        var room=window.innerHeight-navTop-12-64;
        navCount=Math.min(navItems.length,Math.max(1,Math.floor((room-44)/46)+1));
        var maxStart=Math.max(0,navItems.length-navCount);
        navIndex=Math.min(maxStart,Math.max(0,navIndex));
        var itemsTop=navTop+32;
        navItems.forEach(function(el,i){
          var visible=i>=navIndex&&i<navIndex+navCount;
          el.hidden=!visible;
          if(visible)el.style.top=(itemsTop+(i-navIndex)*46)+'px';
        });
        navUp.hidden=false;navDown.hidden=false;
        navUp.style.left=(left+8)+'px';navDown.style.left=(left+8)+'px';
        navUp.style.top=navTop+'px';
        navDown.style.top=(itemsTop+44+(navCount-1)*46+6)+'px';
        navUp.disabled=navIndex===0;navDown.disabled=navIndex===maxStart;
      }
      panel.style.left=(left+47)+'px';panel.style.top=truck.getBoundingClientRect().top+'px';
      if(truck.hidden){panel.hidden=true;truck.setAttribute('aria-expanded','false')}
      if(search.hidden){searchForm.hidden=true;search.classList.remove('lmg-search-expanded')}
      if(gift.hidden)giftPopup.hidden=true;
      if(boutique.hidden)boutiquePopup.hidden=true;
      if(voerplan.hidden)voerplanPopup.hidden=true;
    }
    var disclosure = document.querySelector('#Details-menu-drawer-container');
    if (disclosure) disclosure.addEventListener('toggle', function () { requestAnimationFrame(update); });
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('focus', refreshCart);
    window.addEventListener('pageshow', refreshCart);
    document.addEventListener('cart:updated', scheduleRefresh);
    document.addEventListener('cart:refresh', scheduleRefresh);
    document.addEventListener('shopify:section:load', scheduleRefresh);
    var observerTarget = document.querySelector('#cart-icon-bubble');
    if (observerTarget) {
      new MutationObserver(scheduleRefresh).observe(observerTarget, { subtree: true, childList: true, characterData: true });
    }
    media.addEventListener('change', update);
    refreshCart();
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();